<div>
  @if (true) {
    <div class="card-div shadow1"  [ngStyle]="changeStyle()">
      @if (isuserHascard) {
        <button class="support-close-button" (click)="closeHelpComponent.emit()" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>
      }
      <div class="heading">
        <h1 class="support-text" >{{ 'help.Support' | translate }}</h1>
        <span class="help">  {{ 'help.Werehereforyou' | translate }}</span>
      </div>
      <ng-content></ng-content>
      <div
        style="margin-right:2px !important;margin-left:2px !important;margin-bottom:10px !important;margin-top:10px !important;" >
        <ng-container >
          <div class="supportBox">
            <div class="support-item">
              <button class="btn button-normal">
                <div class="icon-circle">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone w-5 h-5 text-white" aria-hidden="true"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>
                </div>
                <span class="view">Phone</span>
              </button>
              <div class="phone-number">
                <a data-rel="external" class="support-item-detail" href="{{'tel:'+this.getPhoneNo()}}">USA: {{getPhoneNo()}}</a>
                <a data-rel="external" class="support-item-detail" href="{{'tel:'+this.getNetherlandPhone()}}">Netherlands: {{getNetherlandPhone()}}</a>
              </div>
            </div>
          </div>
          <a [href]="contactNumber | safeurl: 'sms:'" class="supportBox" data-rel="external">
            <div class="support-item">
              <button class="btn button-normal">
                <div class="icon-circle">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                </div>
                <span class="view"> {{ 'support.Text' | translate }}</span>
              </button>
              <div class="phone-number">
                <div class="support-item-detail">USA: {{getPhoneNo()}}</div>
              </div>
            </div>
          </a>
          <a href="{{'mailto:'+ getEmailId()}}" class="supportBox" data-rel="external">
            <div class="support-item">
              <button class="btn button-normal">
                <div class="icon-circle">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <span class="view"> {{ 'support.Email' | translate }}</span>
              </button>
              <div class="phone-number">
                <div class="support-item-detail">{{getEmailId()}}</div>
              </div>
            </div>
          </a>
          @if (!this.isZohoSIQChatOffline()) {
            <div class="supportBox" (click)="openZSIQChatWidowClick();">
              <div class="support-item">
                <button class="btn button-normal">
                  <div class="icon-circle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                    </svg>
                  </div>
                  <span class="view">Chat</span>
                </button>
                <div class="phone-number">
                  <div class="support-item-detail">{{ 'support.ChatWithUs' | translate }}</div>
                </div>
              </div>
            </div>
          }
          @if (canAccessHelpCenter()) {
            <div class="supportBox" (click)="openHelpCenter();">
              <div class="support-item">
                <button class="btn button-normal">
                  <div class="icon-circle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"></path>
                    </svg>
                  </div>
                  <span class="view">{{ 'support.HelpCenter' | translate }}</span>
                </button>
                <div class="phone-number">
                  <div class="support-item-detail">{{ 'support.BrowseArticlesOrRequestHelp' | translate }}</div>
                </div>
              </div>
            </div>
          }
        </ng-container>
      </div>
    </div>
  }
</div>
@if (!this.userAccountInfoService.userhascard &&  this.njoySpecificBuild) {
  <app-navigation></app-navigation>
}
